import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects to data-controller="schedule-kanban"
export default class extends Controller {
  static targets = ["column"]

  connect() {
    this.initializeSortables()
  }

  disconnect() {
    this.sortables?.forEach(sortable => sortable.destroy())
  }

  initializeSortables() {
    this.sortables = []

    this.columnTargets.forEach(column => {
      const sortable = Sortable.create(column, {
        group: "schedule",
        animation: 150,
        ghostClass: "opacity-50",
        dragClass: "shadow-lg",
        handle: ".drag-handle",
        draggable: ".kanban-card",
        onEnd: this.handleDrop.bind(this)
      })
      this.sortables.push(sortable)
    })
  }

  async handleDrop(event) {
    const card = event.item
    const jobId = card.dataset.jobId
    const targetColumn = event.to
    const sourceColumn = event.from
    const scheduledDate = targetColumn.dataset.date

    // Don't do anything if dropped in same column
    if (targetColumn === sourceColumn) return

    // Visual feedback while processing
    card.classList.add("ring-2", "ring-brand-500", "opacity-75")

    try {
      const response = await fetch(`/schedule/${jobId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: new URLSearchParams({
          scheduled_date: scheduledDate || "",
          scheduled_time: card.dataset.scheduledTime || ""
        })
      })

      if (response.ok) {
        // Let Turbo handle the DOM updates via Turbo Stream response
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        // Revert on error - move card back
        sourceColumn.appendChild(card)
        this.showError(card)
      }
    } catch (error) {
      console.error("Schedule update failed:", error)
      // Revert on error
      sourceColumn.appendChild(card)
      this.showError(card)
    }
  }

  showError(card) {
    card.classList.remove("ring-brand-500", "opacity-75")
    card.classList.add("ring-red-500")
    setTimeout(() => {
      card.classList.remove("ring-2", "ring-red-500")
    }, 2000)
  }
}
